package org.example.project.engineslot

import androidx.compose.runtime.Composable
import org.example.project.utils.All
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

@Composable
fun SlotSharedLayout(
    headline: String,
    address: String,
    config: All,
    bookings: List<All>,
    slotMode: String = SLOT_VIEW_OPERATIV,
    selectedDate: String,
    selectedStandort: String,
    selectedCell: All?,
    editMode: Boolean = false,
    showGrid: Boolean = true,
    actionBar: @Composable () -> Unit,
    topContent: @Composable () -> Unit,
    onCellClick: (All, All?) -> Unit,
    onCellToggleDisabled: ((All) -> Unit)? = null,
    onBookingHover: ((All, Double, Double) -> Unit)? = null,
    onBookingHoverEnd: (() -> Unit)? = null,
    onCellDoubleClick: (All, All?) -> Unit = { _, _ -> }
) {
    org.jetbrains.compose.web.css.Style(SlotStyles)

    Div({ classes(SlotStyles.screenRoot) }) {
        SlotTopBarLayout(
            headline = headline,
            address = address,
            actionBar = actionBar,
            topContent = topContent
        )

        if (showGrid) {
            SlotGridLayout(
                config = config,
                bookings = bookings,
                slotMode = slotMode,
                selectedDate = selectedDate,
                selectedStandort = selectedStandort,
                selectedCell = selectedCell,
                editMode = editMode,
                onCellClick = onCellClick,
                onCellToggleDisabled = onCellToggleDisabled,
                onBookingHover = onBookingHover,
                onBookingHoverEnd = onBookingHoverEnd,
                onCellDoubleClick = onCellDoubleClick
            )
        }
    }
}
